import apiClient from '@/api/apiClient.js';

export default {
  namespaced: true,
  state: {
    schema: {},
  },

  getters: {
    schema(state) {
      return state.schema;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.proLegalSchema();
        const schema = res.data;
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
  },
};
